/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Integration_Present_2Inputs */



/**
* | output |
* | --- |
* | "working with connected tools" |
*
* @param {Chat_Summary_Integration_Present_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_integration_present_2 = /** @type {((inputs?: Chat_Summary_Integration_Present_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Integration_Present_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("arbeite mit verbundenen Tools")
	return /** @type {LocalizedString} */ ("working with connected tools")
});